import { useState } from "react";
import emailjs from "emailjs-com";

const initialState = {
  name: "",
  email: "",
  message: "",
};

export const ContactForm = () => {
  const [, setFormData] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  const clearState = () => setFormData({ ...initialState });

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm("service_madani", "template_madani", e.target, "zniL1HecqNei7O3pa")
      .then(
        (result) => {
          console.log(result.text);
          clearState();
          e.target.reset();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div className="col-md-8">
      <div className="section-title">
        <h2>Get In Touch</h2>
        <p>
          Please fill out the form below to send us an email and we will
          get back to you as soon as possible.
        </p>
      </div>
      <form name="sentMessage" validate='false' onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <input
                type="text"
                id="name"
                name="name"
                className="form-control"
                placeholder="Name"
                required
                onChange={handleChange}
              />
              <p className="help-block text-danger"></p>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <input
                type="email"
                id="email"
                name="email"
                className="form-control"
                placeholder="Email"
                required
                onChange={handleChange}
              />
              <p className="help-block text-danger"></p>
            </div>
          </div>
        </div>
        <div className="form-group">
          <textarea
            name="message"
            id="message"
            className="form-control"
            rows="4"
            placeholder="Message"
            required
            onChange={handleChange}
          ></textarea>
          <p className="help-block text-danger"></p>
        </div>
        <div id="success"></div>
        <button type="submit" className="btn btn-custom btn-lg">
          Send Message
        </button>
      </form>
    </div>
  );
};
